import {
  ChangeDetectionStrategy,
  Component,
} from '@angular/core';
import { Observable } from 'rxjs';
import { TourItemStateDto } from '../../models/tour.model';
import { TourService } from '../../services/tour.service';

@Component({
  selector: 'calsoft-tour-step-list',
  templateUrl: './tour-step-list.component.html',
  styleUrls: ['./tour-step-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TourStepListComponent {

  readonly steps$: Observable<TourItemStateDto[]> = this.tourService.steps$;
  readonly currentIndex$: Observable<number> = this.tourService.currentStepIndex$;

  constructor(private readonly tourService: TourService) {}

  selectStep(index: number): void {
    this.tourService.selectStep(index);
  }

  getStepIcon(status: TourItemStateDto['status']): string {
    switch (status) {
      case 'COMPLETED': return 'check_circle';
      case 'IN_PROGRESS': return 'play_circle';
      case 'SKIPPED': return 'skip_next';
      default: return 'radio_button_unchecked';
    }
  }

  trackByStateId(_: number, item: TourItemStateDto): number {
    return item.stateId;
  }
}
